import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

export default function NotFound() {
  const navigate = useNavigate();

  const token = Cookies.get("Admin_Token");
  const isLogin = !!token
  console.log("token", token, isLogin)

  const handleRedirect = ()=>{

    if(isLogin){
      navigate("/dashboard")
    }else{
      navigate("/login")
    }

  }
  return (
    <div className="flex flex-col items-center justify-center min-h-screen text-center px-4 bg-lightbg">
      
      {/* 404 Text */}
      <h1 className="text-6xl font-bold text-gray-800 mb-4">404</h1>

      {/* Message */}
      <h2 className="text-2xl font-semibold mb-2">
        Page Not Found
      </h2>

      <p className="text-gray-500 mb-6">
        The page you are looking for doesn't exist or has been moved.
      </p>

      {/* Buttons */}
      <div className="flex gap-4">
        {/* <button
          onClick={() => navigate(-1)}
          className="px-5 py-2 bg-gray-200 rounded-lg hover:bg-gray-500 cursor-pointer"
        >
          Go Back
        </button> */}

        <button
          onClick={handleRedirect}
          className="px-5 py-2 bg-primary text-white rounded-lg hover:bg-primary/80 hover:text-black cursor-pointer"
        >
         {isLogin ? "Go to Dashboard" : "Go to Login"} 
        </button>
      </div>
    </div>
  );
}